module.exports = __webpack_public_path__ + "img/img_logo.64225d46.svg";